module.exports = __webpack_public_path__ + "img/tour-26.fa61e4d8.png";